import { gql } from "@apollo/client";

const UPDATE_COMMODITY = gql`
  mutation updateItem($inputs: [UpdateItemInput!]!) {
    itemUpdate(inputs: $inputs) {
      id
      name
      measurementUnit
      status
      retail
      wholeSale
      retailPrices {
        price
      }
    }
  }
`;

export { UPDATE_COMMODITY };
